import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import type { EndpointBuilder } from '@reduxjs/toolkit/query/endpointDefinitions';
import type { FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/fetchBaseQuery';
import type { ApiResponse } from '../../types/api';
import type { UserStatistics, StatisticsResponse } from '../../types/statistics';

// Statistics API endpoints
export const statisticsApiEndpoints = (builder: EndpointBuilder<BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>, never, 'api'>) => ({
  getUserStats: builder.query<{
    photo_count: number;
    event_count: number;
    storage_used: number;
    usage_percentage: number;
    recent_activity?: {
      uploads_last_7_days: number[];
      views_last_7_days: number[];
    };
  }, void>({
    query: () => '/statistics/user',
    transformResponse: (response: ApiResponse<UserStatistics>) => ({
      photo_count: response.data.uploaded_photos,
      event_count: response.data.active_events,
      storage_used: response.data.storage_used_mb,
      usage_percentage: response.data.usage_percentage,
      recent_activity: response.data.recent_activity
    }),
    providesTags: ['Statistics'],
  }),
  
  getUserStatistics: builder.query<UserStatistics, void>({
    query: () => '/statistics/user',
    transformResponse: (response: StatisticsResponse) => response.data,
    providesTags: ['Statistics']
  }),
  
  getEventStatistics: builder.query<UserStatistics['statistics_by_event'], number>({
    query: (eventId) => `/statistics/event/${eventId}`,
    transformResponse: (response: ApiResponse<UserStatistics>) => {
      const eventId = response.data.statistics_by_event[0]?.event_id;
      return response.data.statistics_by_event.filter((stat: { event_id: number }) => stat.event_id === eventId);
    },
    providesTags: (_result, _error, eventId) => [{ type: 'Statistics', id: eventId }]
  }),
}); 